// extracted by mini-css-extract-plugin
export default {"container":"GeneralInsurance_container__eB+lU"};